import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { catchError, map } from 'rxjs';
import { SavedFilterType } from './models/saved-filter-type.model';
import { CriteriaNamesItem, SavedFilters } from './models/saved-filters.model';
import { SavedFiltersRepository } from './repository/saved-filters-repository';

interface SavedFiltersSuggesterState {
  savedFiltersSuggestions: CriteriaNamesItem[];
  selectedFilter: CriteriaNamesItem | null;
}

const initialState: SavedFiltersSuggesterState = {
  savedFiltersSuggestions: [],
  selectedFilter: null
};

export const SavedFiltersSingleSuggesterStore = signalStore(
  withState<SavedFiltersSuggesterState>(initialState),
  withMethods(store => {
    const savedFiltersRepository = inject(SavedFiltersRepository);
    const destroyRef = inject(DestroyRef);

    return {
      setInitialData: (filterType: SavedFilterType) => {
        savedFiltersRepository
          .getSavedFilters(filterType)
          .pipe(
            map((filters: SavedFilters) => {
              patchState(store, { savedFiltersSuggestions: filters.criteriaNames });
            }),
            catchError(() => {
              patchState(store, { savedFiltersSuggestions: [] });
              return [];
            }),
            takeUntilDestroyed(destroyRef)
          )
          .subscribe();
      },

      setSelectedFilter(selectedFilter: CriteriaNamesItem | null): void {
        patchState(store, () => ({ selectedFilter }));
      }
    };
  })
);
